import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'z-1 h-fit w-full gap-2 py-1',
    container: 'flex-center container flex flex-col gap-6',
    carousel:
      'mx-auto w-fit max-w-full [--slide-size:auto] [--slide-spacing:10px]',
    pickUpCareMobile: 'block max-sm:w-full sm:hidden',
    pickUpCare: 'hidden sm:block',
    brandIconWrapper: 'flex-center hidden sm:flex',
    arrowPrev:
      'border-text-main hover:bg-text-main right-auto left-0 mx-0 h-10 w-10 rotate-180 rounded-full border-1 bg-[#F7F7F7] hover:opacity-100 lg:ml-0',
    arrowNext:
      'border-text-main hover:bg-text-main right-0 left-auto mx-0 h-10 w-10 rotate-0 rounded-full border-1 bg-[#F7F7F7] hover:opacity-100',
    arrowIcon:
      'h-10 w-10 [&>path]:origin-[50%_50%] [&>path]:scale-50 hover:[&>path]:stroke-white'
  },
  variants: {
    withoutGap: {
      true: {
        container: 'max-sm:gap-0'
      }
    }
  },
  defaultVariants: {}
});
